import { MRT_TableInstance, MRT_ToggleGlobalFilterButton } from "material-react-table"

interface RightTableFilterProps<TData extends Record<string, any>> {
    table: MRT_TableInstance<TData>
    rest?: React.ComponentProps<typeof MRT_ToggleGlobalFilterButton<TData>>
}

export function StandardToggleGlobalFilterButton<TData extends Record<string, any>>({
    table,
    ...rest
}: RightTableFilterProps<TData>) {
    return <MRT_ToggleGlobalFilterButton table={table} id="mrt-search-button" {...rest} />
}
